import { BaseEntity } from "yt-ng-framework";
import { NgbDate } from "@ng-bootstrap/ng-bootstrap";

export class OsobaSrodstvoView extends BaseEntity{
    constructor(){
        super();
    }

    Srodstvo:string = null;
    SrodOsoba:string=null;    
    Pol:string=null;
    DatumRodj:NgbDate=null;
    SamohraniRoditelj:boolean = null;
    Osiguranje:boolean = null;
    Lbo:number = null;
    Zaposleni:string = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.Srodstvo=input.Srodstvo;
        this.SrodOsoba=input.SrodOsoba;        
        this.Pol=input.Pol;
        this.DatumRodj=input.DatumRodj;
        this.SamohraniRoditelj=input.SamohraniRoditelj;
        this.Osiguranje=input.Osiguranje;
        this.Lbo=input.Lbo;
        this.Zaposleni=input.Zaposleni;
        return this;
    }

    Serialize(input:OsobaSrodstvoView){
        return input;
    }
}